import { useCallback, useEffect, useState } from 'react';
import type { FeatureName } from '../types';

export interface FeatureTourDismissalLocalStorage {
  featureTourKeyNotFound: boolean | null;
  setFeatureTourKey: (shouldShowTour: boolean) => void;
}

export interface UseFeatureTourLocalStorage {
  userId?: number;
  featureName?: FeatureName;
}

const generateFeatureTourDismissedKey = (userId?: number, featureName?: FeatureName) =>
  `hasDismissedAlert:${featureName}:UserId:${userId}`;

export const useFeatureTourLocalStorage = ({
  userId,
  featureName,
}: UseFeatureTourLocalStorage): FeatureTourDismissalLocalStorage => {
  const [hasDismissedFeatureTour, setHasDismissedFeatureTour] = useState<boolean | null>(null);

  useEffect(() => {
    if (!userId || !featureName) {
      return;
    }
    const featureTourDismissedKey = generateFeatureTourDismissedKey(userId, featureName);

    const localStorageData = localStorage.getItem(featureTourDismissedKey) === 'true';
    setHasDismissedFeatureTour(localStorageData);
  }, [userId, featureName]);

  const setFeatureTourKey = useCallback(
    (shouldShowTour: boolean) => {
      if (!userId || !featureName) {
        return;
      }
      const featureTourDismissedKey = generateFeatureTourDismissedKey(userId, featureName);
      if (!shouldShowTour) {
        localStorage.setItem(featureTourDismissedKey, 'true');
      } else {
        localStorage.removeItem(featureTourDismissedKey);
      }
    },
    [userId, featureName],
  );

  return {
    featureTourKeyNotFound: hasDismissedFeatureTour === null ? null : !hasDismissedFeatureTour,
    setFeatureTourKey,
  };
};
